export default function Footer() {
  return (
    <footer className="bg-[#363636] text-white py-4 text-center">
      <p>&copy; 2025 WAW Calculator</p>
      <p>For tips, tricks, and strats, checkout the <a href="https://www.reddit.com/r/wearewarriors/">reddit</a></p>
      <p>Found an error? Let me know in<a href= "https://www.reddit.com/r/wearewarriors/comments/1l0ipme/calculator_website_update/" > reddit </a></p>
      <p>Upcoming Web Update: Serious refactoring. Figuring out New Hero Calculations after getting update</p>
    </footer>
  );
}